export function isInviteOnlySubscription(subscription: {status?: string; metadata?: Record<string, unknown> | null}): boolean {
  return subscription.status === 'trialing' && subscription.metadata?.promo === true && subscription.metadata?.cardless === true;
}
